import FdnNotification from "@fdn/notification";
import FdnNotificationContainer from "@fdn/notification_container";
import PropTypes from "prop-types";

const Desktop = ({ ...props }) => (
	<FdnNotificationContainer
		id="group-notification"
		width="auto"
		top="var(--fd-space-12)"
		right="0"
		left="auto"
		padding="var(--fd-space-0) var(--fd-space-8) var(--fd-space-0) var(--fd-space-0)"
	>
		<>
			{props.data.map((notification) => (
				<FdnNotification
					isMobile={false}
					id={notification.id}
					key={`${notification.id}-mobile`}
					title={notification.title}
					type={notification.type}
					onClose={props.onClose}
					width="400px"
					duration={3000}
					closeable
					buttonText={notification.buttonText || ""}
					cta={() => props.handleSeenNotif(notification)}
					body={notification.body || ""}
				/>
			))}
		</>
		<style>
			{`
				.notification__learn-more-button {
					border:none !important;
					background:none;
				}
			`}
		</style>
	</FdnNotificationContainer>
);

Desktop.propTypes = {
	data: PropTypes.arrayOf(Object),
	onClose: PropTypes.func.isRequired,
	handleSeenNotif: PropTypes.func.isRequired,
};

Desktop.defaultProps = {
	data: [],
};
export default Desktop;
